import { Post } from 'lib/types';
import { useApi } from 'lib/contexts/ApplicationState';
import { Help } from '@mui/icons-material';
import { MobileTooltip } from 'components/MobileTooltip';
import { ConceptCard } from 'features/Concepts/ConceptCard';
import { Concept } from 'lib/types/projects';
import Link from 'next/link';
import { useQuery } from '@tanstack/react-query';

interface Props {
  post: Post;
}

export const PostConcepts = ({ post }: Props) => {
  const API = useApi();

  const { data: concepts } = useQuery<Concept[] | undefined>({
    queryKey: ['getConceptsForPost', post.id],
    queryFn: () => API.getConceptsForPost(post.id),
    enabled: !!post.id,
    staleTime: 2 * 60 * 1000, // Cache for 2 minutes
  });

  return (
    <>
      {concepts && concepts.length > 0 && (
        <>
          <div className="border-t pt-4 flex flex-wrap justify-between items-center">
            <div className="flex items-center">
              <h5 className="font-semibold text-2xl mr-2">Concepts That Use This Post</h5>
              <MobileTooltip title="This post has been associated with a concept.">
                <Help color="secondary" />
              </MobileTooltip>
            </div>
            <Link href="/teams/brainstorm" className="underline">
              View all concepts
            </Link>
          </div>
          <div className="overflow-x-scroll">
            <div className="flex gap-4 max-w-xs">
              {
                concepts.map((c) => (
                  <ConceptCard
                    key={c.id}
                    concept={c}
                    hideButtons
                  />
                ))
              }
            </div>
          </div>
        </>
      )}
    </>
  );
};
